(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      $(document).find('.section-header').removeClass('header__overlay'); 
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      if(this.hasAttribute('fixed-nav')){
        $(document).find('.section-header').toggleClass('header__overlay'); 
      }
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  document.addEventListener("scroll", (event) => {
    var header = document.querySelector('.section-header'),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop,
    headerOffsetTop = header.offsetTop,
    headerOffsetHeight = header.offsetHeight,
    headerPosTop = headerOffsetTop + headerOffsetHeight + 100;
    if (scrollTop > headerPosTop) {
      header.classList.add('scrolled-past-header');
    }else if (scrollTop <= headerPosTop) {
      header.classList.remove('scrolled-past-header');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("scroll", (event) => {
    var header = document.querySelector('.section-header'),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop,
    headerOffsetTop = header.offsetTop,
    headerOffsetHeight = header.offsetHeight,
    headerPosTop = headerOffsetTop + headerOffsetHeight + 100;
    if (scrollTop > headerPosTop) {
      header.classList.add('scrolled-past-header');
    }else if (scrollTop <= headerPosTop) {
      header.classList.remove('scrolled-past-header');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (e) => {
    if (window.matchMedia("(max-width: 989px)").matches) {
      $(document).find('.shop-the__look-products').find('.card--media').addClass('card--horizontal');
    }
  });
  window.addEventListener("resize", function(){
    if (window.matchMedia("(max-width: 989px)").matches) {
      $(document).find('.shop-the__look-products').find('.card--media').addClass('card--horizontal');
    }else{
      $(document).find('.shop-the__look-products').find('.card--media').removeClass('card--horizontal');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
